export default {
    path: '',
    component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
    children: [
        {
            path: '',
            component: () => import('@/page/distributor/component/admin-layout/index.vue'),
            children: [
                {
                    path: '/electronic-contract',
                    name: 'electronic-contract',
                    component: () => import('./index.vue'),
                    meta: {
                        nav_list_for_admin_layout_head_nav: [
                            { name: `个人中心` },
                            { name: `电子合同` },
                        ],
                    },
                },
            ]
        },
    ]
};
